import { render, staticRenderFns } from "./CustomText.vue?vue&type=template&id=537267fa"
import script from "./CustomText.vue?vue&type=script&lang=js"
export * from "./CustomText.vue?vue&type=script&lang=js"
import style0 from "./CustomText.vue?vue&type=style&index=0&id=537267fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports